// extracted by mini-css-extract-plugin
export default {"listCoach":"styles_listCoach__lcpxl","header_coach":"styles_header_coach__4a2a7","device_number":"styles_device_number__M+fnT"};